module.exports = __webpack_public_path__ + "img/avatar-66.9f9c585b.png";